// src/utils/http.js
import axios from 'axios';
import { useGameStore } from '../store/game.js'

// 判断是否是开发环境
const isDev = process.env.NODE_ENV === 'development'

// 生产环境从 VUE_APP_API_HOST 读取 API 主机，回退到原有默认
const PROD_API_HOST = process.env.VUE_APP_API_HOST || 'https://api.xbyl28.com'

const http = axios.create({
  // 开发环境使用代理，生产环境直接调用
  baseURL: isDev ? '/api' : PROD_API_HOST,
  timeout: 10000,  // 10秒超时
  headers: {
    'Content-Type': 'application/json',
  },
});

// 不需要 token 的接口列表
const NO_AUTH_URLS = [
  '/user/login',      // 登录
  '/user/register',   // 注册
];

// 请求拦截器：添加 token 和其他必要的 headers
http.interceptors.request.use(
  (config) => {
    // 检查当前请求的 URL 是否需要 token
    const needsAuth = !NO_AUTH_URLS.some(url => config.url?.includes(url));
    
    if (needsAuth) {
      const gameStore = useGameStore();
      const token = gameStore.getToken();
      
      if (token) {
        config.headers.Authorization = token;
        console.log('Request with token:', config.url, token.substring(0, 20) + '...')
      } else {
        console.warn('No token found for request:', config.url)
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理错误
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理 CORS 错误
    if (!error.response) {
      // 没有响应说明可能是网络错误或 CORS 错误
      console.error('网络错误或 CORS 错误:', error.message);
      console.error('请检查：');
      console.error('1. 网络连接是否正常');
      console.error('2. 后端 API 是否启动');
      console.error('3. 后端是否正确配置了 CORS headers');
      console.error('4. API 地址是否正确:', PROD_API_HOST);
    }
    
    // 处理 401 未授权错误（token 过期）
    if (error.response && error.response.status === 401) {
      console.warn('Token 已过期 (401 错误)，清除 token 并重定向到登录页')
      const gameStore = useGameStore();
      gameStore.saveToken(null);
      window.location.href = '/';
    }
    
    return Promise.reject(error);
  }
);

export default http;
